import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../stores/NavigateStore";

export const useStyles = makeStyles((theme) => ({

    root: {
        display: 'flex',
        width:'100%',
        minHeight: `calc(100vh - ${topHeight}px)`,
        marginTop: topHeight,
        justifyContent:'flex-start',
        alignItems:'center',
        alignContent:'space-evenly',
        flexDirection:'column',
    },

    container: {
        display:'flex',
        flexDirection:'column',
        justifyContent:'flex-start',
        width: 1000,
        height:'100%',
    },

    mobileContainer: {
        width: '100%',
        height:'100%',
        display:'flex',
        flexDirection:'column',
        justifyContent:'flex-start',
    },
    header: {
        width: '100%',
        justifyContent:'center',
        padding: '20px',
        textAlign: 'left',
        fontSize: '24px',
        fontWeight: 'bold',
    },
    supportContainer: {
        display: 'flex',
        flexDirection:'column',
        alignItems: 'flex-start',
        height:'95%',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '50%',
        maxWidth: '500px',
        '& input, & textarea': {
            marginBottom: '10px',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
        },
        '& button': {
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 15px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#0056b3',
            },
        },
    },
    footerRoot: {
        width: '100%',
        maxWidth: 1000,
        height:'5%',
    },
    footerBox:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
    },
    footerLeft:{
        // backgroundColor:'yellow'
        marginLeft: '8px'

    },
    footerMiddle:{
        // backgroundColor:'yellow'

    },
    footerRight:{
        // backgroundColor:'blue'
        marginRight: '8px'

    },
    tabPanelContainer: {
        display: 'flex',
        justifyContent: 'center'
    }
}));
